// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__p2H50","errorLogs":"EditorFooter_errorLogs__1ogci"};